import React, { useEffect, useState } from "react";
import dummyUser from "../../../assets/images/dummy/dummy-user.png";

const SafeImg = ({ src, alt, style, className }) => {
  const [imgSrc, setImgSrc] = useState(src || dummyUser);

  useEffect(() => {
    setImgSrc(src || dummyUser);
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt || "user"}
      style={style}
      className={className}
      onError={() => setImgSrc(dummyUser)}
      crossOrigin="anonymous"
    />
  );
};

export { SafeImg };
export default SafeImg;
